import React from "react";
import "./Terms.css";
import laptop from "./laptop.png";
import Breadcrumb from "../../components/breadcrumb/Breadcrumb";

export default function Terms() {
  return (
    <div className="pt-2 pt-md-4 bg-secondary terms poppins">
      <Breadcrumb page="Terms & Conditions" image={laptop} />
      <div className="container box-shadow  bg-white py-4">
        <div className="px-3 px-md-5">
          <h4 className="text-primary">TERMS OF USE:</h4>
          <p>
            PLEASE READ CAREFULLY THESE TERMS OF USE. THE USE OF THIS WEBSITE,
            WOULD BE DEEMED AS YOUR ACCEPTANCE OF THE TERMS OF IT’S USAGE. YOU
            MAY NOT USE THE WEBSITE, IF YOU DO NOT AGREE WITH ITS USAGE TERMS.
          </p>
          <p>
            We thank you for interest shown in 2nd Gear.com. 2nd Gear.com is the
            exclusive property of 2nd Gear Services Limited, a company
            registered under the laws of India, hereinafter referred to as “Us”,
            “We”, or “2nd Gear.com”. The following Site Usage Terms and
            Conditions govern the terms of your use of www.2gear.in Website and
            the Service is provided subject to these terms and conditions .
          </p>
          <p>
            We thank you for interest shown in 2nd Gear.com. 2nd Gear.com is the
            exclusive property of 2nd Gear Services Limited, a company
            registered under the laws of India, hereinafter referred to as “Us”,
            “We”, or “2nd Gear.com”. The following Site Usage Terms and
            Conditions govern the terms of your use of www.2gear.in Website and
            the Service is provided subject to these terms and conditions
          </p>
          <p>
            The Terms of Use have to be considered jointly with our Privacy
            Policy and our Pricing Policy.
          </p>
        </div>
        <div className="px-3 px-md-5">
          <h5 className="text-primary">Websites Descriptions:</h5>
          <p>
            The site is an online marketplace/ platform only. It is designed
            with a view to offer common place of interaction/ business to who
            own machines, equipments and tools (“Items”) and people who want to
            hire/ sell such products on rent/ sale. www.2gear.in is not part of
            the Rental/ Sale Agreement executed between members of the Site.
          </p>
          <p>
            www.2gear.in does not in any manner verify correctness or
            authenticity or can be made liable for the information put up on its
            site by Owners/ Sellers to rent/ sell the Items listed by them or
            the ability/capacity of Hirers/ Buyers to hire/ buy or pay for the
            rental/ sale consideration of any Items. www.2gear.in cannot be made
            liable for failure of the either party i.e. the Owner/ Seller and
            Hirer/Buyer to complete the transaction. The parties are free to
            determine their own terms and conditions for the Rental/ Sale
            Agreement and www.2gear.in is not responsible for the collection,
            retention, or refunding of any security deposit or guarantees or
            collecting money owed by the Hirer/ Buyer to the Owner/ Seller or
            vice versa.
          </p>
          <p>
            The Terms of Use have to be considered jointly with our Privacy
            Policy and our Pricing Policy.
          </p>
        </div>
        <div className="px-3 px-md-5">
          <h5 className="text-primary">Capacity to Contract:</h5>
          <p>
            Our services are reserved for person’s lawfully capable or executing
            legally binding rental/ sale contract in India. These services are
            available only for the persons who have attained majority as per
            Majority Act. Minors are not permitted to use the site. If you do
            not comply with these conditions, you cannot use our services.
          </p>
        </div>
        <div className="px-3 px-md-5">
          <h5 className="text-primary">Registration:</h5>
          <p>
            Registration as Members is required to use certain features of the
            site. 2nd Gear.com in its sole discretion, reserves the right to
            disapprove any request to become a Member or to suspend or terminate
            the authorisation to use/ access the site without giving any reason.
            It would be duty of the Members to provide correct, complete and
            accurate information or details pertaining to them and to update
            them from time to time. www.2gear.in reserves the right to
            disapprove any application or suspend or close or terminate
            authorisation of Member site without assigning any reason or without
            cause.
          </p>
          <p>
            Registration of a Member Account implies, in particular, to provide
            a valid email address that will be used to communicate between the
            Member and the Site, and will be used as the unique identifier for
            the Member Account. All email communications sent by the Site to the
            Member is understood as having been received by the Member, who
            takes full knowledge thereof. In addition, the Member accepts to
            provide a physical address, which is required for publication of
            Rental/ Sale Listings by Owners/ Sellers.
          </p>
          <p>
            www.2gear.in (including its parent company, its affiliates, its
            officers, directors, agents, subsidiaries, joint ventures or
            employees) would not be held liable for claims, demands or damages
            (actual and consequential) of any kind for the closing of a Member
            Account.
          </p>
        </div>
        <div className="px-3 px-md-5">
          <h5 className="text-primary">Members Responsibility:</h5>
          <p>
            After being registered as a Member, you agree to abide by the Terms
            and Conditions contained in this site. You also agree to abide by
            the Buyer/ Seller/ Owner/ Hirer Terms and Conditions while buying,
            selling or renting of Equipment/ material.
          </p>
          <p>
            The Members agree to identify, verify or authenticate the origin of a Rental/ Listing. It is agreed that the site would not be used for
            making false statements or diffusion of confidential, illegal or offensive content. The Members agrees not to engage in (i) use,
            copying or diffusion of copyright protected works without express            authorization, (ii) upload invalid data, viruses, worms or other
            software agents through the site, (iii) impersonate another person
            or conducting fraud, hiding or attempting to hide your identity
            otherwise misrepresenting your identity, (iv) abusive or fraudulent
            use of collaboration tools (spam of comments, spam of clicks etc),
            (v) circumvent measures taken by site to prevent or restrict access
            to the Services.
          </p>
          <p>
            In case, you have any objection to any of the term or condition, any
            guidelines, or any subsequent modifications thereto or become
            dissatisfied with 2nd Gear.com in any way, your only recourse is to
            immediately discontinue usage of 2nd Gear.com.
          </p>
        </div>
        <div className="px-3 px-md-5">
          <h5 className="text-primary">Login id, password & security:</h5>
          <p>
            The Member Account is personal and cannot be transferred to a third
            party. The member commits to keep confidential the password he /
            she/ it chooses for accessing his/ her/ its Member Account. The
            Member Account and the password are personal and cannot be shared,
            communicated or transferred to any other individual or entity,
            except as required by law.
          </p>
          <p>
            Any unauthorised use of any login ID and/ or password or any other
            breach of security regarding the Site has to be immediately informed
            by the Member to www.2gear.in
          </p>
        </div>
        <div className="px-3 px-md-5">
          <h5 className="text-primary">
            Commissions Owed By Owner/ Seller and Hirer/ Buyer to 2nd Gear.com
          </h5>
          <p>
            Except for promotional offers that are explicitly published on the
            Site, a commission is owed by the Owner/ Seller and the Hirer/ Buyer
            to www.2gear.in, in accordance with the Pricing Policy, when they
            agree to execute Rental/ Sale Agreement.
          </p>
          <p>Fees and Commissions</p>
          <p>
            The usage, access, registration and listing of machines on the
            website is not chargeable. The details relating to payment of
            commissions, paid tools and services available on the site are
            contained in Pricing Policy available on the Website. However, we
            reserve the right to change the Pricing Policy at any time, which
            shall take effect once it is published online. The Members are
            required to check the Terms of Use and Pricing Policy and in any
            case before any transaction. Unless posted otherwise, the fees/
            Commissions payable to us would be in Indian Rupees (INR) exclusive
            of any applicable taxes
          </p>
        </div>

        <div className="table-responsive px-3 px-md-5">
          <table className="table table-borderless">
            <thead>
              <tr>
                <td>
                  <h5 className="text-primary">Transaction</h5>
                </td>
                <td>
                  <h5 className="text-primary">Charges</h5>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Machinery Sale</td>
                <td>5% of the sale value payable by the seller and buyer</td>
              </tr>
              <tr>
                <td>Machinery Lease / Rental</td>
                <td>
                  5% of the Lease / Rental value (0 to 90 days) <br />
                  4% of Lease / Rental value (91 to 180 days) <br />
                  3% of Lease / Rental value (more than 180 days)
                </td>
              </tr>
              <tr>
                <td>Machinery Valuation</td>
                <td>5000 INR</td>
              </tr>
              <tr>
                <td>Asset Inspection</td>
                <td>10000 INR</td>
              </tr>
              <tr>
                <td>Manpower recruitment</td>
                <td>8% of the annual compensation</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div
          style={{ backgroundColor: "#F6F5FF" }}
          className="py-1 px-5 fw-500"
        >
          Note: Above mentioned charges are exclusive of taxes
        </div>
        <div className="px-3 px-md-5 mt-3">
          <h5 className="text-primary">Third Party Links</h5>
          <p>
            The Content available on or through the Site may contain links to
            other websites that are not owned or controlled by www.2gear.in No
            representation or endorsement or warranty as to the accuracy,
            completeness or authenticity of the information contained in any
            such website is made by 2nd Gear.com. If you access a third party
            website, then you do so at your own risk.
          </p>
        </div>
        <div className="px-3 px-md-5">
          <h5 className="text-primary">
            Rental/ Sale Listings and Rental/ Sale Transactions
          </h5>
          <p>
            Items offered for hire/ sale by the Members can only include text,
            documents and images that the Members decide to upload, at their
            sole responsibility. The Owner/ Seller has to ensure that the Items
            listed for hire/ sale have been listed in the appropriate category.
            Owner/ Seller are solely responsible for choosing the category in
            which they place the item for Rent/ sale.
          </p>
        </div>
        <div className="px-3 px-md-5">
          <h5 className="text-primary">
            Owner/ Seller Must Have Rights to The Item Offered For Hire/ Sale
          </h5>
          <p>
            The Owner/ Seller must either have ownership of the Item, or be
            lawfully allowed to rent/ sell the Item which he/ she/ it lists for
            hire/ sale.
          </p>
          <p>
            The Owner/ Seller always offers for hire/ sale of machines, tools or
            equipments that the Owner/ Seller can physically deliver to the
            Hirer/ buyer or can be picked up in a given location by the Hirer/
            buyer, either at the Owner’s/ Seller’s address or at another one of
            his/ her/ its rental locations.
          </p>
          <p>No Exchange of Contact Information</p>
          <p>
            The Owner/ seller, either an individual or a professional, is not
            allowed in any case to publish any contact information within its
            Rental/ Sale Listing. The physical address of the rental/ sale
            location, the Owner’s/ Seller’s address, their fax or telephone, an
            email address or a website address are all considered as contact
            information.
          </p>
          <p>
            From the moment of the online publication of a Rental/ Sale Listing
            for an Item, until the moment the Owner/ Seller accepts the request
            of the Hirer/ Buyer, the Owner/ Seller and the potential Hirer/
            Buyer cannot exchange (whether or not through the Site) their
            identity, their contact information, the address of the Owner/
            Seller, Hirer/ Buyer or Rental Location, their fax or telephone
            numbers, email address or a web address.
          </p>
        </div>
        <div className="px-3 px-md-5">
          <h5 className="text-primary">Content of Rental Listings</h5>
          <p>
            2nd Gear.com also has the right to monitor, edit, and partially or
            totally delete any content found in Rental/ Sale Listings. Users and
            members agree not to ask for any form of financial compensation/
            damages in relation to the use of the Content published on
            www.2gear.in
          </p>
          <p>
            www.2gear.in has no obligation of diligence with regards to the
            publication of content. 2nd Gear.com May Publish Rental Listings on
            Partner Websites.
          </p>
        </div>
        <div className="px-3 px-md-5">
          <h5 className="text-primary">
            Conclusion of a Rental/ Sale Agreement/Binding Agreement
          </h5>
          <p>
            The rental/ Sale of a item between an Owner and a Hirer put in
            contact through the site can only be done through the site.
          </p>
          <p>
            The Owner/ Seller is free to choose with whom, if anyone, he or she
            would like to enter into a Rental/ Sale Agreement. However, once the
            Owner/ Seller has accepted the Request of the hirer/ buyer, then
            they agree that the Rental/ Sale Agreement is binding. Once the
            hirer/ buyer has paid and owner/ seller has accepted agreed rental/
            sale consideration, then the commission shall not be refunded even
            if they back out from the deal.
          </p>
        </div>
        <div className="px-3 px-md-5">
          <h5 className="text-primary">
            Additional Terms Relating of Sale of Items
          </h5>
          <p>
            All the items listed for sale/ rent are governed by the terms of
            warranties provided by the respective manufacturers. In the event
            You purchase any Item/s from the Sellers, www.2gear.in shall not be
            liable for any fault arising from or in these item/s. You are
            requested to contact the nearest service centre for getting the Item
            serviced or for rectification of any fault. Buyer acknowledges that
            the Seller is solely responsible for Items being sold by it on
            www.2gear.in Further, Buyer agrees that www.2gear.in will not be
            held liable for failure of the Seller to make available any Item or
            his failure to complete a sale of an Item. 2nd Gear.com specifically
            disclaims any liability with regard to any defective item purchased
            or service availed by Buyer from the Seller and www.2gear.in
          </p>
          <p>
            shall not assume any liability if the item purchased or service
            availed by Buyer from the Seller is not exactly as per
            specifications detailed in the website listing or the order. Except
            for promotional offers that are explicitly published on the Site, a
            commission is owed by both the Buyer and the Seller to 2nd Gear.com,
            in accordance with the Pricing Policy (see also chapter 4 above).
          </p>
        </div>
        <div className="px-3 px-md-5">
          <h5 className="text-primary">Submit Bid/Buy Now Terms</h5>
          <p>
            By clicking on "Submit Bid" you are "Making an Offer" "Make an
            Offer" of the amount which you wish to pay for the product. Once
            your offer is accepted, you can make the payment online.
          </p>
          <p>
            The "BUY NOW" purchase option enables a quick sale and implies that
            you agree to buy the product at the listed price. We will notify the
            seller and on obtaining the approval from seller, facilitate the
            payment.
          </p>
        </div>
        <div className="px-3 px-md-5">
          <h5 className="text-primary">Modifications</h5>
          <p>
            www.2gear.in reserves the right, without any limits or restrictions
            and at its sole discretion, to modify in whole or in part and at any
            time, its Policies. All changes will be effective once published on
            the Site. Use of the Site after these changes have been published
            constitutes your acceptance of the modified Policies. www.2gear.in
            reserves the right to modify, interrupt, or end at any time any
            service, without taking responsibility for the consequences
            resulting from these modifications, interruptions or ending of these
            services.
          </p>
          <p>Liability of www.2gear.in</p>
        </div>
        <div className="px-3 px-md-5">
          <h5 className="text-primary">Disclaimer of warranties</h5>
          <p>
            You agree that use of the Site and the Service is entirely at your
            own risk. The Site and the Service are provided on an "as is" or "as
            available" basis, without any warranties of any kind. All express
            and implied warranties, including, without limitation, the
            warranties of merchantability, fitness for a particular purpose, and
            non-infringement of proprietary rights are expressly disclaimed to
            the fullest extent permitted by law. To the fullest extent permitted
            by law, 2nd Gear.com disclaims any warranties for the security,
            reliability, timeliness, accuracy, and performance of the Site, the
            Service rental/ sale listings, or any rental/ sale agreement. To the
            fullest extent permitted by law.
          </p>
          <p>
            www.2gear.in disclaims any warranties for other Services or goods
            received through or advertised on the Site or the Sites or Service,
            or accessed through any links on the Site. To the fullest extent
            permitted by law, www.2gear.in disclaims any warranties for viruses
            or other harmful components in connection with the Site or the
            Service.
          </p>
        </div>
        <div className="px-3 px-md-5">
          <h5 className="text-primary"> Limitations of liability</h5>
          <p>
            Under no circumstances shall 2nd Gear.com be liable for direct,
            indirect, incidental, special, consequential or exemplary damages
            (even if www.2gear.in has been advised of the possibility of such
            damages), resulting from your use of the Site or the Service, or
            resulting from any rental/ sale agreement, whether the damages arise
            from use or misuse of the Site or the Service, from inability to use
            the Site or the Service, or the interruption, suspension,
            modification, alteration, or termination of the Site, the Service or
            member account. Such limitation shall also apply with respect to
            damages incurred by reason of other Services or products received
            through or advertised in connection with the Site or the Service or
            any links on the Site, as well as by reason of any information or
            advice received through or advertised in connection with the Site or
            the Service or any links on the Site. These limitations shall apply
            to the fullest extent permitted by law.
          </p>
        </div>

        <div className="px-3 px-md-5">
          <h5 className="text-primary">Taxes, Licenses, and Certifications</h5>
          <p>
            2nd Gear.com does not pay any taxes on behalf of the Users or
            Members of the Site. Users and Members are solely liable for any
            taxes resulting from any Rental/ Sale Agreement or use of our
            Services or Site.
          </p>
          <p>
            Whether you are a business entity or individual, or whether you are
            an Owner/ Seller or a Hirer/ Buyer, you agree that you are solely
            responsible to determine what taxes, if any, apply to you and to pay
            any such taxes to the concerned authorities/ Government Bodies. 2nd
            Gear.com recommends that you seek advice from a tax professional.
            Depending on the circumstances, such as the number of transactions
            you conduct, the subject matter of the transaction, licenses or
            certifications might be applicable to you. You agree that it is your
            sole responsibility to obtain any licenses or certifications that
            might be required to conduct a transaction or otherwise use the
            Services or Site. 2nd Gear.com is not responsible for determining
            whether or not you should be licensed and/or certified for the use
            of the Services or Site, or for conducting a transaction. 2nd
            Gear.com makes no representation or guarantee about licensing or
            certification of its Users or Members.
          </p>
        </div>
        <div className="px-3 px-md-5">
          <h5 className="text-primary">Intellectual Property</h5>
          <p>
            www.2gear.in cannot be aware of all the content published on the
            site in all the Rental Listings or in the comments. However, 2nd
            Gear.com commits to remove as quickly as possible any copyright
            protected material once notified.
          </p>
          <p>
            The brand 2nd Gear.com is an applied trademark and is fully and
            exclusively owned by Global Spectrum Private Limited. All graphic
            elements, design elements, presentations, logos relative to 2nd
            Gear.com.com are the exclusive property of 2nd Gear.com. Any
            reproduction without www.2gear.in written authorization is strictly
            prohibited.
          </p>
          <p>Proprietary Rights</p>
          <p>
            Subject to our Privacy Policy, any Content that you transmit to the
            Site or to us, whether by electronic mail or other means, for any
            reason, will be treated as non-confidential and non-proprietary.
            While you might retain all rights in such communications or
            material, you grant us and our designated licensees a non-exclusive,
            paid-up, perpetual, and worldwide right to copy, distribute,
            display, perform, publish, translate, adapt, modify, and otherwise
            use such material for any purpose regardless of the form or medium
            (now known or not currently known) in which it is used.
          </p>
          <p>
            Please do not submit confidential or proprietary information to us
            unless we have mutually agreed in writing otherwise. We respect the
            intellectual property of others, and we ask you to do the same. If
            you or any User of the Site believes its copyright, trademark or
            other property rights have been infringed by a posting on the Site,
            you or the User should send notification to us immediately. To be
            effective, the notification must include:
          </p>
        </div>

        <div className="px-3 px-md-5">
          <h5 className="text-primary">Proprietary Rights</h5>
          <p>
            Subject to our Privacy Policy, any Content that you transmit to the
            Site or to us, whether by electronic mail or other means, for any
            reason, will be treated as non-confidential and non-proprietary.
            While you might retain all rights in such communications or
            material, you grant us and our designated licensees a non-exclusive,
            paid-up, perpetual, and worldwide right to copy, distribute,
            display, perform, publish, translate, adapt, modify, and otherwise
            use such material for any purpose regardless of the form or medium
            (now known or not currently known) in which it is used.
          </p>
          <p>
            Please do not submit confidential or proprietary information to us
            unless we have mutually agreed in writing otherwise. We respect the
            intellectual property of others, and we ask you to do the same. If
            you or any User of the Site believes its copyright, trademark or
            other property rights have been infringed by a posting on the Site,
            you or the User should send notification to us immediately. To be
            effective, the notification must include:
          </p>
          <p>
            a physical or electronic signature of a person authorized to act on
            behalf of the owner of an exclusive right that is allegedly
            infringed;
          </p>
          <p>
            Identification of the copyrighted work claimed to have been
            infringed;
          </p>
          <p>
            Information reasonably sufficient to permit us to contact the
            complaining party, such as address, telephone number and, if
            available, an electronic mail address at which the complaining party
            may be contacted;
          </p>
          <p>
            Identification of the material that is claimed to be infringing or
            to be subject to infringing activity and that is to be removed and
            information reasonably sufficient to permit us to locate the
            materials;
          </p>
          <p>
            A statement that the complaining party has a good faith belief that
            use of the material in the manner complained of is not authorized by
            the copyright owner, agent, or the law; and A statement that the
            information in the notification is accurate and that the complaining
            party is authorized to act on behalf of the owner of an exclusive
            right that is allegedly infringing. You acknowledge and agree that
            upon receipt of a notice of a claim of copyright infringement, we
            may immediately remove the identified materials from our Site.
          </p>
        </div>
        <div className="px-3 px-md-5">
          <h5 className="text-primary">Indemnification</h5>
          <p>
            Upon a request by us, you agree to defend, indemnify, and hold 2nd
            Gear.com and its Affiliates harmless from all liabilities, claims,
            damages, compensation and expenses, including attorney's fees that
            arise from your use or misuse of Site. We reserve the right, at our
            own expense, to assume the exclusive defense and control of any
            matter otherwise subject to indemnification by you, in which event
            you will cooperate with us in asserting any available defences.
          </p>
        </div>

        <div className="px-3 px-md-5">
          <h5 className="text-primary">No agency relationship</h5>
          <p>
            www.2gear.in and Members or Users are independent parties, each
            acting in its name and for its own purpose. The relationship between
            2nd Gear.com and its users/ members shall be on Principal to
            Principal basis. Nothing in this Terms of Use or other 2nd Gear.com
            Policies shall be deemed to constitute, create, give effect to or
            otherwise recognize a partnership, agency, joint venture or formal
            business entity of any kind or create a fiduciary or similar
            relationship among the parties; and the rights and obligations of
            the parties shall be limited to those expressly set forth herein.
          </p>
        </div>

        <div className="px-3 px-md-5">
          <h5 className="text-primary">Legal Fees</h5>
          <p>
            The user or member accepts to defend and compensate www.2gear.in
            (including reasonable lawyer fees), its agents, directors,
            administrators, employees, Owners, and representatives against any
            request or claim made by a third party, caused by or resulting from
            a violation or any other act for which the user or member is
            responsible, that arose from them not upholding the instructions,
            guarantees and/or obligations contained in the present General Terms
            of Use, or having violated any law or any regulation of this third
            party. This includes but is not limited to complaints and legal
            claims with regards to: infringement or violation of intellectual
            property rights, defamation or privacy rights.
          </p>
          <p>
            www.2gear.in reserves the right, at its sole discretion, to organize
            the defense with a lawyer of their choosing, against all legal
            claims, legal suits or other affairs that request financial
            compensation from the user or the member.
          </p>
        </div>
        <div className="px-3 px-md-5">
          <h5 className="text-primary">
            Applicable Law and Legal Jurisdiction
          </h5>
          <p>
            The user or member accepts to defend and compensate www.2gear.in
            (including reasonable lawyer fees), its agents, directors,
            administrators, employees, Owners, and representatives against any
            request or claim made by a third party, caused by or resulting from
            a violation or any other act for which the user or member is
            responsible, that arose from them not upholding the instructions,
            guarantees and/or obligations contained in the present General Terms
            of Use, or having violated any law or any regulation of this third
            party. This includes but is not limited to complaints and legal
            claims with regards to: infringement or violation of intellectual
            property rights, defamation or privacy rights.
          </p>
          <p>
            www.2gear.in reserves the right, at its sole discretion, to organize
            the defence with a lawyer of their choosing, against all legal
            claims, legal suits or other affairs that request financial
            compensation from the user or the member.
          </p>
        </div>

        <div className="px-3 px-md-5 border-0">
          <h5 className="text-primary">Additional Conditions</h5>
          <p>
            You accept that the rights and obligations contained in the present
            Terms of Use as well as any other documents that are incorporated to
            it by way of reference may be freely and rightfully transferred by
            www.2gear.in to a third party in the event of a merger or
            acquisition or of another event.
          </p>
          <p>
            No derogation to the present Terms of Use will be authorized, unless
            a written authorization is obtained and a new contract is signed by
            you and www.2gear.in
          </p>
          <p>
            All notifications at your attention will be sent to the email
            address you provided when signing up to www.2gear.in Messages and
            notifications are considered received 24 hours after the email has
            been sent, unless we receive a notification stating that the email
            address is not valid or functioning.
          </p>
          <p>Other www.2gear.in terms and conditions</p>
          <p>
            The terms of use must be read in conjunction with all other
            www.2gear.in terms and conditions. These terms and conditions
            contribute to the present terms of use and also have a contractual
            value.
          </p>
        </div>
      </div>
    </div>
  );
}
